export const GET_DOWNLOAD_INFO = 'GET_DOWNLOAD_INFO'
export const GET_DOWNLOAD_SIGNEDURL = 'GET_DOWNLOAD_SIGNEDURL'
